/* eslint-disable @typescript-eslint/no-unused-vars */
import { useScopelyIdentityContext, useWebStoreContext } from "contexts";
import { useLocation } from "react-router-dom";

export const useScopelySignUp = () => {
	const location = useLocation();
	const { logout } = useWebStoreContext();
	const { startLogin, initiateLogin, isScopelyIdentityReady } =
		useScopelyIdentityContext();

	return {
		startLogin,
		logout,
		location,
		initiateLogin,
		isScopelyIdentityReady
	};
};
